import { axios } from "../../api";
import router from "../../router";

export default {
    state: {
        employee: [],
        notes: {},
        getListNotes: [],
    },
    getters: {
        employee: (state) => state.employee,
        notes: (state) => state.notes,
        getListNotes: (state) => state.getListNotes,
    },
    actions: {
        GET_EMPLOYEE({ commit }) {
            axios
                .get("/getCashier")
                .then((res) => {
                    commit("GET_EMPLOYEE", res.data);
                })
                .catch((err) => console.log(err));
        },
        POST_NOTES({ commit }, payload) {
            commit("POST_NOTES", payload);
        },
        GET_LIST_NOTES({ commit }) {
            axios
                .get("/getNoteCashier")
                .then((res) => {
                    commit("GET_LIST_NOTES", res.data);
                })
                .catch((err) => console.log(err));
        },
    },
    mutations: {
        GET_EMPLOYEE(state, payload) {
            state.employee = payload;
        },
        async POST_NOTES(state, payload) {
            state.notes = {
                name: payload.name,
                notes: payload.notes,
            };
            await axios
                .post("/postNoteCashier", state.notes)
                .then(() => {
                    router.push("/noteslist");
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        GET_LIST_NOTES(state, payload) {
            state.getListNotes = payload;
        },
    },
};
